module.exports = __webpack_public_path__ + "img/pulldown.0889d633.svg";